/**
 * Returns true if the cartbox should be visible for the given path.
 * @param path Current location pathname
 */
export const shouldShowCartbox = (path: string): boolean => {
    const excludedPaths = [
        '/',
        '/entry',
        '/garage',
        '/last-configurations',
        '/compare',
        '/check',
        '/checkout',
    ]

    return !excludedPaths.includes(path)
}
